export default __webpack_public_path__ + "static/media/typepickup.cddd7067.svg";